module.exports = __webpack_public_path__ + "h5/img/huyuan-top.85f3c5ae.png";